import { STUDIO_BALK, TASKBAR_H, TOOL_MAX } from '../lib/config.js';

/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

export default {
  incBrush() { return this.setState((s) => ({ brushSize: Math.min(4, s.brushSize + 1) })); },

  decBrush() { return this.setState((s) => ({ brushSize: Math.max(1, s.brushSize - 1) })); },

  selectPencil() { this.setState({ tool: 'pencil', sel: null, lassoPts: null }); },

  selectEraser() { this.setState({ tool: 'eraser', sel: null, lassoPts: null }); },

  selectFill() { this.setState({ tool: 'fill', sel: null, lassoPts: null }); },

  selectSpray() { this.setState({ tool: 'spray', sel: null, lassoPts: null }); },

  // Kader en lasso delen één vakje: je begint met het kader, nog een keer L
  // (of nog een klik) wisselt naar de vrije lasso.
  selectSelect() {
      if (this.state.tool === 'select') { this.setState({ tool: 'marquee', sel: null, lassoPts: null }); return; }
      if (this.state.tool === 'marquee') { this.setState({ tool: 'select', sel: null, lassoPts: null }); return; }
      this.setState({ tool: 'marquee' });
    },

  // De sneltoetsen springen wél rechtstreeks naar één van de twee, net zoals /, R
  // en O rechtstreeks naar een vorm springen terwijl P door de vormen loopt. L gaf
  // eerst hetzelfde als M, en dan staat er op het sneltoetsenkaartje "L lasso"
  // terwijl je het kader kreeg.
  selectMarquee() { this.setState({ tool: 'marquee', sel: null, lassoPts: null }); },

  selectLasso() { this.setState({ tool: 'select', sel: null, lassoPts: null }); },

  isSelectTool(t) { return t === 'select' || t === 'marquee'; },

  // Cirkel, lijn en rechthoek delen één vakje: P (of nog een klik) wisselt.
  // O, / en R springen rechtstreeks naar hun vorm.
  //
  // De pen zat hier ooit als vierde bij. Die is eruit; de tekencode ervoor staat
  // nog in draw.js en pointer.js maar is niet meer te bereiken, want `tool` wordt
  // nergens meer 'pen' en die waarde wordt ook niet bewaard. Het vakje heet in de
  // vals nog steeds `pen`: dat is de sleutel van de knop en van zijn tipje.
  setShapeTool(t) {
      this.setState({ tool: t, sel: null, lassoPts: null });
    },

  /**
   * De hulplijnen onder het doek: uit, kubus, isometrisch, uit.
   *
   * Eén knop en geen twee, want het is één soort hulp met twee vormen, en de
   * kolom heeft geen plek voor alles. Dezelfde ronde die de vormknop hierboven
   * doet met cirkel, lijn en rechthoek.
   *
   * Ze liggen onder je tekening en niet erover. Dat is het hele punt: je tekent
   * eroverheen en waar je een pixel zet is de lijn weg. Een raster bovenop zou je
   * eigen werk verstoppen.
   */
  cycleHulp() {
      const ring = ['', 'kubus', 'iso'];
      const at = ring.indexOf(this.state.hulp || '');
      this.setState({ hulp: ring[(at + 1) % ring.length] });
    },

  selectPen() {
      const ring = ['circle', 'line', 'rect'];
      const at = ring.indexOf(this.state.tool);
      const next = at < 0 ? 'circle' : ring[(at + 1) % ring.length];
      this.setState({ tool: next, sel: null, lassoPts: null });
    },

  // De gereedschapskolom moet altijd in één beeld passen: 11 knoppen, twee
  // streepjes en de tussenruimtes worden uit de schermhoogte teruggerekend.
  /**
   * Hoe groot de gereedschapsknoppen worden.
   *
   * Ze rekten mee tot de kolom precies vol was, en op een hoog scherm werden dat
   * elf zeer forse knoppen naast een canvas dat er klein bij stond. Nu is zestig
   * de bovengrens: precies de maat van de kleurvakjes aan de andere kant, dus
   * links en rechts staan even grote knoppen. Blijft er onderaan ruimte over, dan
   * is dat gewoon lucht.
   *
   * Naar beneden rekt hij nog wel: past het niet, dan krimpen ze mee tot dertig.
   */
  toolMetrics() {
      // Elf knoppen: zes gereedschappen, de hulplijnen, twee voor de dikte en twee
      // voor ongedaan maken en opnieuw. Daartussen drie streepjes van 3px.
      const rows = 11;
      // Op een computer staat de kolom in een venster van een vaste maat, dus rekent
      // hij daarmee; op de telefoon met de hoogte van het beeld. Anders werden de
      // knoppen te groot voor het venster en klemde de onderste onder de rand.
      // Dezelfde hoogte als het venster zelf. Stond op STUDIO_H, en dat is sinds
      // studioHoog een bovengrens en niet meer de maat: op een laptop van dertien
      // inch rekende de kolom zich dus hoger dan het venster is.
      const hoog = this.state.isMobile ? this.state.winH : this.studioHoog();
      const gap = hoog < 720 ? 5 : 8;
      // De kop is 64 en de taakbalk ook, plus 24 padding in de kolom en twee
      // streepjes. Die taakbalk stond hier niet in, dus op een telefoon van 568 hoog
      // rekende hij de knoppen te groot en werden ongedaan maken en opnieuw onder de
      // balk geklemd door de overflow:hidden van de kolom.
      // De rand van het venster telt ook mee: vier boven en vier onder.
      const kader = this.state.isMobile ? 64 + TASKBAR_H : STUDIO_BALK + 8;
      /**
       * Dertien gaten, niet tien.
       *
       * In de kolom staan veertien dingen: elf knoppen en drie streepjes. Daar zitten
       * dus dertien gaten tussen. Dit rekende met `rows - 1` en kwam daarmee drie
       * gaten te kort, ruim twintig pixels. Op een schermvullende studio viel dat
       * binnen de marge; in een venster van vaste maat scrolde de kolom en hing de
       * onderste knop half onder de rand. Nagemeten in de browser.
       */
      const dingen = rows + 3;
      const avail = hoog - kader - 24 - 3 * 3 - gap * (dingen - 1);
      const size = Math.max(30, Math.min(TOOL_MAX, Math.floor(avail / rows)));
      return { size, gap, showKeys: size >= 42, icon: size >= 52 ? 24 : (size >= 42 ? 22 : (size >= 36 ? 19 : 16)) };
    },

  // Een sneltoets laat dezelfde knop even indrukken als een echte klik.
  flashKey(name) {
      clearTimeout(this.keyFlashT);
      this.setState({ keyFlash: name });
      this.keyFlashT = setTimeout(() => this.setState({ keyFlash: null }), 180);
    },

  pressFx(name) {
      if (this.state.keyFlash !== name) return null;
      return { transform: 'translate(3px,3px) scale(.97)', boxShadow: '0 0 0 var(--ink)' };
    },

  // De knoppen rekken mee zodat de kolom precies tot de menubalk vult.
  /**
   * De naam die een schermlezer voorleest bij een gereedschapsknop.
   *
   * Die knoppen tonen alleen een icoontje en hebben geen `title`, want ze gebruiken
   * de eigen paarse tooltip. Zonder naam hoor je dus "knop, knop, knop". De tekst
   * komt uit dezelfde `toolTips` als de tooltip zelf, zodat de twee niet uit elkaar
   * kunnen lopen.
   */
  toolLabelFor(name, active) {
      const tip = this.toolTips[name];
      if (!tip) return name;
      const label = tip.key ? tip.title + ', sneltoets ' + tip.key : tip.title;
      return active ? label + ', geselecteerd' : label;
    },

  toolStyle(active, name) {
      const m = this.toolMetrics();
      return Object.assign({
        // Even breed als hoog, en in het midden van de kolom. Alleen de hoogte stond
        // hier, en dan rekte de knop mee met de kolom: 58 breed en 50 hoog zodra het
        // venster lager was dan de kolom voor 58 in de hoogte nodig had.
        flex: '0 0 auto', height: m.size + 'px', width: m.size + 'px', alignSelf: 'center',
        boxSizing: 'border-box', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: m.showKeys ? '3px' : '0',
        borderRadius: '12px', border: '3px solid var(--ink)', cursor: 'pointer',
        background: active ? 'var(--paars)' : '#fff', color: active ? '#fff' : 'var(--ink)'
      }, this.pressFx(name));
    },

  brushCellStyle(disabled, name) {
      const m = this.toolMetrics();
      return Object.assign({
        flex: '0 0 auto', height: m.size + 'px', width: m.size + 'px', alignSelf: 'center',
        boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: '12px', border: '3px solid var(--ink)', cursor: disabled ? 'not-allowed' : 'pointer',
        background: '#fff', color: 'var(--ink)', opacity: disabled ? 0.35 : 1
      }, disabled ? null : this.pressFx(name));
    },

  tabStyle(active) {
      const nh = !this.state.isMobile && this.state.narrowHeader;
      return {
        position: 'relative', zIndex: 1, flex: '1 1 0', minWidth: nh ? '80px' : '104px',
        border: 'none', cursor: 'pointer', borderRadius: '12px', padding: nh ? '8px 10px' : '8px 20px',
        fontWeight: '600', fontSize: nh ? '14px' : '15px', background: 'transparent',
        color: active ? '#fff' : 'var(--ink)'
      };
    }
};
